module.exports = __webpack_public_path__ + "568041ec4e40da2a161b213d8a4985db.png";